export const initDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('LMS_DB', 1);
        request.onerror = (e) => reject('IndexedDB error');
        request.onsuccess = (e) => resolve(e.target.result);
        request.onupgradeneeded = (e) => {
            const db = e.target.result;
            if (!db.objectStoreNames.contains('translationsStore')) {
                db.createObjectStore('translationsStore');
            }
        };
    });
};

export const setTranslationsCache = async (data) => {
    try {
        const db = await initDB();
        const tx = db.transaction('translationsStore', 'readwrite');
        const store = tx.objectStore('translationsStore');
        store.put(data, 'translations');
        return new Promise((resolve, reject) => {
            tx.oncomplete = () => resolve(true);
            tx.onerror = () => reject(tx.error);
        });
    } catch (e) {
        console.error('Error saving to IndexedDB', e);
    }
};

export const getTranslationsCache = async () => {
    try {
        const db = await initDB();
        const tx = db.transaction('translationsStore', 'readonly');
        const store = tx.objectStore('translationsStore');
        const request = store.get('translations');
        return new Promise((resolve, reject) => {
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    } catch (e) {
        console.error('Error reading from IndexedDB', e);
        return null;
    }
};
